var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_2721203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.75 88.874H47.7848C44.8013 88.874 41.9398 90.0593 39.8299 92.1691L35.625 96.374L45 105.749L49.5267 101.222C50.2301 100.519 51.1838 100.124 52.1784 100.124H63.75C66.8566 100.124 69.375 97.6057 69.375 94.499C69.375 91.3924 66.8566 88.874 63.75 88.874Z",
    fill: "#FAB991"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M90.7767 86.2225C89.3123 84.7579 86.9379 84.7579 85.4735 86.2225L71.5718 100.124H52.1784C51.184 100.124 50.2301 100.519 49.5267 101.222L45 105.749L50.625 111.374L54.375 107.624H72.3485C73.8511 107.624 75.2637 107.039 76.3259 105.977L90.7767 91.5257C92.2411 90.0613 92.2411 87.6871 90.7767 86.2225Z",
    fill: "#F0915A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M63.7499 97.6241H62.5C61.4645 97.6241 60.625 96.7846 60.625 95.7491V93.249C60.625 92.2136 61.4645 91.374 62.5 91.374H63.7499C65.4759 91.374 66.8748 92.7732 66.8748 94.4989C66.8748 96.2251 65.4759 97.6241 63.7499 97.6241Z",
    fill: "#F0915A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.0759 95.8255L45 105.75L35.625 115.125H13.125L32.4241 95.8255C33.1563 95.0933 34.3437 95.0933 35.0759 95.8255Z",
    fill: "#5F78BE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M45 105.749L51.1741 111.923C51.9063 112.655 51.9063 113.843 51.1741 114.575L50.625 115.124H35.625L45 105.749Z",
    fill: "#46508C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M99.375 62.624H24.375C20.2329 62.624 16.875 59.2661 16.875 55.124V13.874C16.875 9.73191 20.2329 6.37402 24.375 6.37402H99.375C103.517 6.37402 106.875 9.73191 106.875 13.874V55.124C106.875 59.2661 103.517 62.624 99.375 62.624Z",
    fill: "#46508C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M91.875 62.624H24.375C20.2329 62.624 16.875 59.2661 16.875 55.124V13.874C16.875 9.73191 20.2329 6.37402 24.375 6.37402H91.875C96.0171 6.37402 99.375 9.73191 99.375 13.874V55.124C99.375 59.2661 96.0171 62.624 91.875 62.624Z",
    fill: "#5F78BE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.875 17.624H99.375V28.874H16.875V17.624Z",
    fill: "#FAA51E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M106.875 28.874H99.375V17.624H106.875V28.874Z",
    fill: "#F06423"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M58.125 78.5615C68.9981 78.5615 77.8125 69.7471 77.8125 58.874C77.8125 48.0009 68.9981 39.1865 58.125 39.1865C47.2519 39.1865 38.4375 48.0009 38.4375 58.874C38.4375 69.7471 47.2519 78.5615 58.125 78.5615Z",
    fill: "#F06423"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M58.125 41.999C67.4299 41.999 75 49.5691 75 58.874C75 68.1789 67.4299 75.749 58.125 75.749C48.8201 75.749 41.25 68.1789 41.25 58.874C41.25 49.5691 48.8201 41.999 58.125 41.999ZM58.125 36.374C45.6987 36.374 35.625 46.4475 35.625 58.874C35.625 71.3004 45.6987 81.374 58.125 81.374C70.5513 81.374 80.625 71.3004 80.625 58.874C80.625 46.4475 70.5513 36.374 58.125 36.374Z",
    fill: "#FAA019"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M58.125 33.5614C56.5718 33.5614 55.3125 32.3021 55.3125 30.7489V27.624C55.3125 26.0708 56.5718 24.8115 58.125 24.8115C59.6782 24.8115 60.9375 26.0708 60.9375 27.624V30.7489C60.9375 32.3021 59.6782 33.5614 58.125 33.5614Z",
    fill: "#FFCD06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M58.125 92.9364C56.5718 92.9364 55.3125 91.6772 55.3125 90.1239V86.999C55.3125 85.4458 56.5718 84.1865 58.125 84.1865C59.6782 84.1865 60.9375 85.4458 60.9375 86.999V90.1239C60.9375 91.6774 59.6782 92.9364 58.125 92.9364Z",
    fill: "#FFCD06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.7667 47.624C33.2896 47.624 32.806 47.5024 32.3631 47.2469L29.6567 45.6843C28.3117 44.9076 27.8506 43.1875 28.6271 41.8422C29.4036 40.4969 31.1235 40.0364 32.4692 40.8126L35.1756 42.3752C36.5206 43.1519 36.9817 44.872 36.2052 46.2173C35.6844 47.1197 34.7387 47.624 33.7667 47.624Z",
    fill: "#FFCD06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M85.1846 77.3115C84.7074 77.3115 84.2239 77.1898 83.7812 76.9343L81.0749 75.3718C79.7296 74.5953 79.2685 72.875 80.0453 71.5299C80.8217 70.1843 82.5421 69.7238 83.8871 70.5003L86.5937 72.0629C87.9388 72.8393 88.3998 74.5597 87.6233 75.9047C87.1021 76.8071 86.1566 77.3115 85.1846 77.3115Z",
    fill: "#FFCD06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M31.0656 77.3117C30.0937 77.3117 29.1482 76.8073 28.6272 75.905C27.8507 74.5597 28.3115 72.8396 29.6568 72.0629L32.3631 70.5003C33.7082 69.7238 35.4283 70.1843 36.2052 71.5299C36.9817 72.8752 36.5209 74.5953 35.1756 75.372L32.4693 76.9346C32.0263 77.1903 31.5428 77.3117 31.0656 77.3117Z",
    fill: "#FFCD06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M82.4836 47.624C81.5116 47.624 80.5662 47.1196 80.0452 46.2173C79.2687 44.8722 79.7294 43.1519 81.0748 42.3754L83.7811 40.8128C85.1259 40.0361 86.8465 40.4971 87.623 41.8424C88.3994 43.1875 87.9387 44.9078 86.5934 45.6843L83.8868 47.2469C83.4443 47.5024 82.9608 47.624 82.4836 47.624Z",
    fill: "#FFCD06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M58.9647 46.8136L62.1693 53.3067L69.3348 54.3478C70.1038 54.4596 70.4108 55.4046 69.8544 55.947L64.6694 61.001L65.8933 68.1375C66.0245 68.9035 65.2208 69.4873 64.533 69.1259L58.124 65.7565L51.715 69.1259C51.0271 69.4875 50.2234 68.9035 50.3547 68.1375L51.5786 61.001L46.3935 55.947C45.8371 55.4046 46.1441 54.4596 46.9131 54.3478L54.0787 53.3067L57.2833 46.8136C57.6271 46.1168 58.6208 46.1168 58.9647 46.8136Z",
    fill: "#FFCD06"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardShare);
export default __webpack_public_path__ + "static/media/rewardShare.f4aa71d27fdff315ee186cca3bf976f8.svg";
export { ForwardRef as ReactComponent };